<script setup lang="ts">

import { AppMultiSelect } from '@shared/ui/selects'
import { BtnTertiary } from '@shared/ui/buttons'
import { FilterDateRange } from '@shared/ui/filters'
import { FilterTutors } from '@entities/tutor'

import { useFiltersTutorAttendanceRates } from '../model/filters-tutor-attendance-rates.hook'

defineOptions({
  name: 'FiltersTutorAttendanceRates',
})

const {
  refDateRange,
  refTutorIds,
  refStatuses,
  refReasons,
  statusOptions,
  reasonOptions,
  isLoading,
  clearFilters,
} = useFiltersTutorAttendanceRates()
</script>

<template>
  <div class="filters-tutor-attendance-rates">
    <div class="filters-tutor-attendance-rates__fields">
      <FilterDateRange
        v-model="refDateRange"
        class="filters-tutor-attendance-rates__date"
        label="Date"
        placeholder="Select range"
      />

      <FilterTutors
        v-model="refTutorIds"
        class="filters-tutor-attendance-rates__tutors"
        :disabled="isLoading"
      />

      <AppMultiSelect
        v-model="refStatuses"
        class="filters-tutor-attendance-rates__select"
        :options="statusOptions"
        label="Lesson status"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <AppMultiSelect
        v-model="refReasons"
        class="filters-tutor-attendance-rates__select"
        :options="reasonOptions"
        label="Reason"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />
    </div>

    <div class="filters-tutor-attendance-rates__controls">
      <BtnTertiary
        text="Clear filters"
        :disabled="isLoading"
        @click="clearFilters"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./FiltersTutorAttendanceRates.scss" />
